export default __webpack_public_path__ + "static/media/lock.58f410e1.svg";